var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('page-header'),_vm._v(" "),_c('div',{staticClass:"page_content flex_center"},[(_vm.slideMenuVisible)?[_c('slide-menu')]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"page_main"},[_c('router-view')],1)],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-637c422c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/index.vue
// module id = null
// module chunks = 